import * as semver from 'semver';

export enum Features {
    SUBTITLE_POLICY_V2
    // Add more features here as needed
}

type FeatureVersionMap = {
    [key in Features]?: string;
};

export class CompatibilityManager {
    private static _instance: CompatibilityManager;
    private _featureVersions: FeatureVersionMap = {};
    private _senderVersion?: string = undefined;

    private constructor() {
        this.registerFeatureVersion(Features.SUBTITLE_POLICY_V2, '3.8.0');
    }

    public static getInstance() {
        return (this._instance ??= new CompatibilityManager());
    }

    /**
     * Checks if a feature is supported based on the set sender version
     * @param feature The feature to check support for (value from Features enum)
     * @returns True if the feature is supported, false otherwise
     */
    public isFeatureSupported(feature: Features): boolean {
        if (!this._senderVersion || !this._featureVersions[feature]) {
            return false; // Feature not supported if sender version or feature version is not set
        }

        const featureVersion = this._featureVersions[feature];
        if (featureVersion == null) {
            return false;
        }

        return semver.satisfies(this._senderVersion, featureVersion);
    }

    /**
     * Registers the minimum version required for a specific feature
     * @param feature The feature to register (value from Features enum)
     * @param minVersion The minimum version required for the feature
     */
    public registerFeatureVersion(feature: Features, minVersion: string): void {
        this._featureVersions[feature] = minVersion;
    }

    /**
     * Sets the sender version for compatibility checks
     * @param version The sender version string
     */
    public setSenderVersion(version: string | undefined): void {
        this._senderVersion = version;
    }
}
